<template>
    <div class="newDetail">
        <navs></navs>
        <div class="banner">
            <banner :img="bannerImg" titleEn="News and information" titleCn="新闻资讯"></banner>
        </div>
        <div class="newDetail_box">
            <div class="all_box">
                <div class="newDetail_body">
                    <h3>{{dataForm.title}}</h3>
                    <div class="futitle">
                        <p class="futitle_time">发表时间：{{dataForm.updateDate}}</p>
                        <p class="futitle_ll">{{dataForm.click}}浏览</p>
                    </div>
                    <div class="newDetail_text" v-html="dataForm.content">
                        <p>测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文
                        </p>
                        <p>测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文</p>
                        <p>测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文测试新闻正文</p>

                    </div>
                </div>
            </div>
        </div>
        <friend></friend>
        <foots></foots>
    </div>
</template>
<script>
    import friend from '@/components/friend.vue'
    import banner from '@/components/banner.vue'
    import navs from '@/components/navs.vue'
    import foots from '@/components/foots.vue'
    import bannerImg from '@/assets/img/new_banner.png'
    export default {
        name: 'newDetail',
        data() {
            return {
                bannerImg: bannerImg
            }
        },


        mounted() {
            this.id = this.$route.query.id
            this.getNewDetail()
        },


        methods: {
            //获取新闻详情
            getNewDetail(){
                this.$http.get(`/attract_investment/front/show/getNewsDetail/${this.id}`).then(({
                    data:res
                })=>{
                    this.dataForm = res
                    this.$forceUpdate()
                })
            }
        },
        components: {
            navs,
            foots,
            banner,
            friend
        }
    }
</script>
<style lang="scss" scoped>
    .newDetail_body {
        h3 {
            font-size: 24px;
            color: #333;
            margin-bottom: 30px;
            text-align:left;
            margin:0;
            
        }

        .futitle {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            font-size: 18px;
            color: #999;
            margin-top: 30px;
            p{
                margin: 0;
            }
        }
    }
    .newDetail_box{
        padding-top: 80px;
        padding-bottom: 200px;
    }
    .futitle_ll {
        margin-left: 40px !important;
    }

    .newDetail_text {
        text-align: left;
        margin-top: 37px;
    }
</style>